document.documentElement.classList.add('js');

function closeHeaderSearch() {
  const panel = document.querySelector('[data-search-panel]');
  const toggle = document.querySelector('[data-search-toggle]');
  if (!panel || panel.hidden) return;
  panel.hidden = true;
  toggle.setAttribute('aria-expanded', 'false');
  document.body.classList.remove('search-is-open');
}

document.addEventListener('click', function (event) {
  const menuToggle = event.target.closest('[data-menu-toggle]');
  const searchToggle = event.target.closest('[data-search-toggle]');
  const searchClose = event.target.closest('[data-search-close]');
  const footerMenuToggle = event.target.closest('[data-footer-menu-toggle]');
  const searchPanel = document.querySelector('[data-search-panel]');

  if (footerMenuToggle) {
    const menu = footerMenuToggle.closest('[data-footer-menu]');
    const open = menu.classList.toggle('is-open');
    footerMenuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    return;
  }

  if (menuToggle) {
    const nav = document.querySelector('[data-mobile-nav]');
    const open = nav.classList.toggle('is-open');
    menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    closeHeaderSearch();
    return;
  }

  if (searchToggle && searchPanel) {
    const opening = searchPanel.hidden;
    searchPanel.hidden = !opening;
    searchToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
    document.body.classList.toggle('search-is-open', opening);

    const nav = document.querySelector('[data-mobile-nav]');
    const mobileToggle = document.querySelector('[data-menu-toggle]');
    if (nav) nav.classList.remove('is-open');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');

    if (opening) {
      window.requestAnimationFrame(function () {
        const input = searchPanel.querySelector('[data-search-input]');
        if (input) input.focus();
      });
    }
    return;
  }

  if (searchClose) {
    closeHeaderSearch();
    const toggle = document.querySelector('[data-search-toggle]');
    if (toggle) toggle.focus();
    return;
  }

  if (searchPanel && !searchPanel.hidden && !event.target.closest('.site-header')) closeHeaderSearch();
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  const panel = document.querySelector('[data-search-panel]');
  if (!panel || panel.hidden) return;
  closeHeaderSearch();
  const toggle = document.querySelector('[data-search-toggle]');
  if (toggle) toggle.focus();
});

const interactiveSelector = 'a[href],button:not([disabled]),summary,[role="button"],input[type="submit"],input[type="button"],input[type="reset"]';
const pressFeedbackTimers = new WeakMap();

function showPressFeedback(target) {
  if (!(target instanceof Element)) return;
  const control = target.closest(interactiveSelector);
  if (!control || control.getAttribute('aria-disabled') === 'true') return;

  const existingTimer = pressFeedbackTimers.get(control);
  if (existingTimer) window.clearTimeout(existingTimer);

  control.classList.remove('is-pressing');
  window.requestAnimationFrame(function () {
    control.classList.add('is-pressing');
    const timer = window.setTimeout(function () {
      control.classList.remove('is-pressing');
      pressFeedbackTimers.delete(control);
    }, 210);
    pressFeedbackTimers.set(control, timer);
  });
}

document.addEventListener('pointerdown', function (event) {
  if (event.button !== 0) return;
  showPressFeedback(event.target);
}, true);

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  showPressFeedback(event.target);
}, true);
